import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { PageLoading } from "@/hooks/useFeatureAccess";

export function RequireSuperAdmin() {
  const { profile, loading, previewMode } = useAuth();

  if (loading && !profile && !previewMode) return <PageLoading />;
  if (previewMode) return <Outlet />;
  if (profile?.role !== "super_admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
}

export function RequireFeature({ featureKey }: { featureKey: string }) {
  const { profile, loading, previewMode, enabledFeatures } = useAuth();

  if (loading && !profile && !previewMode) return <PageLoading />;
  if (previewMode) return <Outlet />;
  if (profile?.role === "super_admin") return <Outlet />;
  if (!enabledFeatures.includes(featureKey)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
}
